<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333333;
  min-height: 100vh;
}
html,body{
  height: 100%;
  margin: 0;
  padding: 0;
}
body{
  width:100%;
  position:relative;
}
.el-menu--horizontal.user-submenu{
  width: 350px;
}
.el-menu--horizontal.user-submenu ul{
    width: 124px;
    padding: 0 10px;
    float: right;
}
</style>



// WEBPACK FOOTER //
// src/App.vue